export enum TRANSLATION_CONTENT_TYPE {
	SEARCH = 'search',
	EVENT = 'event',
	QUESTIONNAIRE = 'questionnaire',
	HOME = 'home',
}

export enum TRANSLATION_KEY {
	NAME = 'name',
	GROUP_NAME = 'groupName',
	ADDRESS = 'address',
	CITY = 'city',
	STATE = 'state',
}